import { render, staticRenderFns } from "./swipertree.vue?vue&type=template&id=55eea735&scoped=true&"
import script from "./swipertree.vue?vue&type=script&lang=js&"
export * from "./swipertree.vue?vue&type=script&lang=js&"
import style0 from "./swipertree.vue?vue&type=style&index=0&id=55eea735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eea735",
  null
  
)

export default component.exports